import { createSlice } from '@reduxjs/toolkit'
import { v4 as uuid } from 'uuid'
import { i18n } from '../i18n'

const initialState: SelectedRoomsState = {
  value: [],
}

export const selectedRoomsSlice = createSlice({
  name: 'selectedRooms',
  initialState,
  reducers: {
    updateSelectedRooms: (state, action) => {
      // ADD
      if (
        action.payload.quantity > 0 &&
        state.value.filter((item) => item.key === action.payload.room.key).length <
          action.payload.quantity
      ) {
        if (action.payload.quantity > 1) {
          // Add indexes to room labels
          const newRooms = [...state.value]
          // Add index to first occurrence of room
          state.value = [
            ...newRooms,
            {
              id: uuid(),
              key: action.payload.room.label,
              label: `${i18n.t(`rooms.${action.payload.room.label}`)} ${action.payload.quantity
                .toString()
                .padStart(2, '0')}`,
            },
          ]
        } else {
          // First and only occurrence, no index needed on label
          state.value = [
            ...state.value,
            {
              id: uuid(),
              key: action.payload.room.label,
              label: `${i18n.t(`rooms.${action.payload.room.label}`)} 01`,
            },
          ]
        }
        // TODO
        // Scroll to recently added element
        // add navigation ref to context to be able to get navigation height here necessary for scroll
      }

      // REMOVE
      if (
        state.value.filter((item) => item.key === action.payload.room.key).length >
        action.payload.quantity
      ) {
        const newRooms = [...state.value]
        // Get last occurrence of room in array and remove it
        const roomKeys = newRooms.map((el) => el.key)
        newRooms.splice(roomKeys.lastIndexOf(action.payload.room.key), 1)

        state.value = newRooms
      }
    },
    loadSheetRooms: (state, { payload: { rooms } }) => {
      state.value = rooms.map((room: any) => {
        const { id, key, label } = room
        return { id, key, label }
      })
    },
    clearSheetRooms: (state) => {
      state.value = initialState.value
    },
    updateSelectedRoomNameById: (state, action) => {
      const { id, label } = action.payload

      const itemToUpdate = state.value.findIndex((item) => item.id === id)

      if (itemToUpdate !== -1) {
        state.value[itemToUpdate].label = label
      }
    },
  },
})

// Action creators are generated for each case reducer function
export const { updateSelectedRooms, loadSheetRooms, clearSheetRooms, updateSelectedRoomNameById } =
  selectedRoomsSlice.actions

export default selectedRoomsSlice.reducer
